/**
 * 用户信息
 * */
export default {
    namespaced: true,
    state: {
        // 用户自定义导航信息
        menu: [{ title: '考核平台', show: true }, { title: '诚信', show: true }, { title: '退货', show: true }, { title: '旅行社', show: true }]
    },
    getters: {
        indexMenu: state => {
            let tmp = []
            state.menu.forEach(item => {
                if (item.show) {
                    tmp.push(item.title)
                }
            })
            return tmp
        }
    },
    actions: {
        /**
         * @description 设置导航
         * @param {Object} state vuex state
         * @param {Object} dispatch vuex dispatch
         * @param {*} info info
         */
        set ({ state, dispatch }, info) {
            return new Promise(async resolve => {
                // store 赋值
                state.menu = info;
                // 持久化
                await dispatch('db/set', {
                    dbName: 'database',
                    path: 'menu',
                    value: info
                }, { root: true });
                // end
                resolve();
            })
        },
        /**
         * @description 从数据库取导航
         * @param {Object} state vuex state
         * @param {Object} dispatch vuex dispatch
         */
        load ({ state, dispatch }) {
            return new Promise(async resolve => {
                // store 赋值
                state.menu = await dispatch('db/get', {
                    dbName: 'database',
                    path: 'menu',
                    defaultValue: {}
                }, { root: true });
                // end
                resolve();
            })
        }
    }
}
